<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="loading">
                    <div class="loading text-center">
                        <br />
                        <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                        <br />
                        <p>Loading, please wait...</p>
                    </div>
                </ng-container>

                <ng-container *ngIf="!loading">

                    <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom breadcrumbsWrab">
                        <div class="breadcrumbs">
                            <span [routerLink]="['/app/users']">Users </span> > <span class="active">{{firstName}} {{lastName}}</span>
                            <div class="emailSpace">
                                <div></div><p class="active">{{email}}</p>
                            </div>
                        </div>

                        <div class="btns-container">

                            <ng-container *ngIf="currentSelectedTab == 0 || currentSelectedTab == 1.0 || currentSelectedTab == 1 || currentSelectedTab == 2 || currentSelectedTab == 3">
                                <a *ngIf="!restoring; else restoringElse;" (click)="restore()" data-toggle="dropdown"
                                   class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-primary': madeChanges, 'btn-gray': !madeChanges}">
                                    <i class="fas fa-download text-white-50"> <span class="button-text"> Restore</span></i>
                                </a>
                                <ng-template #restoringElse>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm loadingBtn margin-right-5">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Restoring
                                    </button>
                                </ng-template>
                            </ng-container>

                            <ng-container *ngIf="currentSelectedTab == 0 || currentSelectedTab == 1.0 || currentSelectedTab == 1 || currentSelectedTab == 2 || currentSelectedTab == 3">
                                <a *ngIf="!saving; else savingElse;" (click)="saveChanges()" data-toggle="dropdown"
                                   class="d-none d-sm-inline-block btn btn-sm shadow-sm" [ngClass]="{'btn-primary': madeChanges, 'btn-gray': !madeChanges}">
                                    <i class="fas fa-save text-white-50"> <span class="button-text"> Save</span></i>
                                </a>
                                <ng-template #savingElse>
                                    <button disabled class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm loadingBtn">
                                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="font-size:20px;padding:0;position: relative;top:0px;"></i> Saving
                                    </button>
                                </ng-template>
                            </ng-container>
                        </div>
                    </div>

                    <div class="topSpacingAssigned">

                        <div class="desktopTabs">
                            <ul class="tab-nav">
                                <li (click)="tabSelect(0)" class="active"><a data-toggle="tab" href="#personalDataTab">Personal data</a></li>
                                <li *ngIf="!isClientOrRater" (click)="tabSelect(1)"><a data-toggle="tab" href="#assessmentsTab">Assessments</a></li>
                                <ng-container *ngIf="status">
                                    <li *ngIf="isClientOrRater" (click)="tabSelect(2)"><a data-toggle="tab" href="#passwordTab">Password</a></li>
                                </ng-container>
                                <li (click)="tabSelect(3)"><a data-toggle="tab" href="#coachesTab">Coaches</a></li>
                            </ul>
                        </div>

                        <div class="main-tab-content tab-content assessmentsComponent">

                            <div id="personalDataTab" class="tab-pane fade  in active">
                                <div class="row">
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold" style="position: relative; top: 3px;">Account Activated: </span>
                                        </div>
                                        <label style="margin-right:15px;">
                                            Yes
                                            <input (change)="changeStatus()" type="radio" [checked]="status" name="status" value="1">
                                            <!-- <span class="checkmark"></span> -->
                                        </label>
                                        <label>
                                            No
                                            <input (change)="changeStatus()" type="radio" [checked]="!status" name="status" value="0">
                                            <!-- <span class="checkmark"></span> -->
                                        </label>
                                    </div>
                                </div>

                                <div class="row">
                                    
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold">User Type: </span>
                                        </div>
                                        <span>{{userType}}</span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold">Email: </span>
                                        </div>
                                        <input class="width50" [(ngModel)]="newEmail" (ngModelChange)="detectChanges()" id="email" name="email" type="email">
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold">First name: </span>
                                        </div>
                                        <input class="width50" [(ngModel)]="firstName" (ngModelChange)="checkForSpecialCharacters($event, 'firstName', false)" id="firstName" name="first" type="text" value="{{firstName}}">
                                        <p class="colorRed fontSmaller d-none errorMessage">First name contains invalid characters</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold">Last name: </span>
                                        </div>
                                        <input class="width50" [(ngModel)]="lastName" (ngModelChange)="checkForSpecialCharacters($event, 'lastName', false)" id="lastName" name="last" type="text" value="{{lastName}}">
                                        <p class="colorRed fontSmaller d-none errorMessage">Last name</p>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 inline-row">
                                        <div class="text-right">
                                            <span class="bold">Registered on: </span>
                                        </div>
                                        <span>{{registrationDate | date: 'dd/MM/yyyy'}}</span>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="!isClientOrRater" id="assessmentsTab" class="tab-pane fade">
                                <div class="desktopTabs">
                                    <ul class="tab-nav assessmentUlTabs">
                                        <li *ngIf="!isClientOrRater" (click)="tabSelect(1.0)" class="active"><a data-toggle="tab" href="#assessmentsComponentTab1">Available</a></li>
                                        <li (click)="tabSelect(1.1)" [ngClass]="{'active': isClientOrRater}"><a data-toggle="tab" href="#assessmentsComponentTab2">Assigned</a></li>
                                        <li (click)="tabSelect(1.2)" id="completedAssessmentsTab"><a data-toggle="tab" href="#assessmentsComponentTab3">Completed</a></li>
                                        <li (click)="tabSelect(1.3)"><a data-toggle="tab" href="#assessmentsComponentTab4">Expired</a></li>
                                    </ul>
                                </div>

                                <div class="main-tab-content tab-content assessmentsContent">
                                    <div *ngIf="!isClientOrRater" id="assessmentsComponentTab1" class="tab-pane fade in active">
                                        <div class="row">
                                            <div class="col-sm-3 text-right leftOnResponsive" style="width: 150px;">
                                                <span class="bold middleAlign">Self Assessments: </span>
                                            </div>
                                            <div class="col-sm-9 input-col-sm-9">
                                                <input class="width50" [(ngModel)]="selfAssessments.Amount"
                                                       (input)="changeStatus('selfAsessmentsAmount', $event.target.value)"
                                                       min="0"
                                                       onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                                                       type="number"
                                                       id="selfAsessmentsAmount"
                                                       value="{{selfAssessments.Amount}}" />
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-3 text-right leftOnResponsive" style="width: 150px;">
                                                <span class="bold middleAlign">360 Assessments: </span>
                                            </div>
                                            <div class="col-sm-9 input-col-sm-9">
                                                <input class="width50" [(ngModel)]="assessments360.Amount"
                                                       (input)="changeStatus('asessments360Amount', $event.target.value)"
                                                       min="0"
                                                       onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                                                       type="number"
                                                       id="asessments360Amount"
                                                       value="{{assessments360.Amount}}" />
                                            </div>
                                        </div>
                                    </div>

                                    <div id="assessmentsComponentTab2" class="tab-pane fade " [ngClass]="{'in active': isClientOrRater}">
                                        <app-assigned></app-assigned>
                                    </div>

                                    <div id="assessmentsComponentTab3" class="tab-pane fade">
                                        <app-completed-assessments></app-completed-assessments>
                                    </div>

                                    <div id="assessmentsComponentTab4" class="tab-pane fade">
                                        <app-expired></app-expired>
                                    </div>
                                </div>
                            </div>

                            <div id="coachesTab" class="tab-pane fade"> 
                               <app-user-coaches-list [userId]="selectedUserId" id="userCoachesListComponent"></app-user-coaches-list>
                            </div>

                            <ng-container *ngIf="status">
                                <div *ngIf="isClientOrRater" id="passwordTab" class="tab-pane fade container-fluid">
                                    <!--<div class="row">
                                        <div class="col-md-2 text-right-on-desktop width-150">
                                            <label>Current password: </label>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <input passwordDirective
                                                   class="form-control"
                                                   #_currentPassword
                                                   style="height:35px;border:1px solid #ccc;padding:5px;"
                                                   id="currentPassword"
                                                   type="password"
                                                   name="currentPassword"
                                                   placeholder="Current password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.currentPassword"
                                                   (keyup)="preventSpace(_currentPassword.value, $event, 'currentPassword')"
                                                   (keypress)="preventSpace(_currentPassword.value, $event, 'currentPassword')" />
                                        </div>
                                    </div>-->

                                    <div class="row">
                                        <div class="col-md-2 text-right-on-desktop width-150">
                                            <label>New password: </label>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <input passwordDirective class="form-control"
                                                   #_password1
                                                   id="password1"
                                                   type="password"
                                                   name="password1"
                                                   style="height:35px;border:1px solid #ccc;padding:5px;"
                                                   placeholder="Password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.password1"
                                                   (keyup)="preventSpace(_password1.value, $event, 'password1')"
                                                   (keypress)="preventSpace(_password1.value, $event, 'password1')"
                                                   (focusout)="confirmationFail()"
                                                   (focusin)="removeMessage()"
                                                   (input)="validForm()" />
                                            <ng9-password-strength-bar [passwordToCheck]="_password1.value"
                                                                       [barColors]="myColors"
                                                                       (onStrengthChanged)="passwordValid($event)">
                                            </ng9-password-strength-bar>
                                            <p id="passWordText" style="font-size: 12px;">
                                                User password must be 8-20 characters long and it must contain at least one number, one capital letter and one symbol.
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2 text-right-on-desktop width-150">
                                            <label>Confirm password: </label>
                                        </div>
                                        <div class="col-sm-6 col-md-4">
                                            <input passwordDirective class="form-control pass2"
                                                   #_password2
                                                   id="password2"
                                                   type="password"
                                                   name="password2"
                                                   style="height:35px;border:1px solid #ccc;padding:5px;"
                                                   placeholder="Confirm password"
                                                   autocomplete="new-password"
                                                   [(ngModel)]="userInfo.password2"
                                                   (keyup)="preventSpace(_password2.value, $event, 'password2')"
                                                   (keypress)="preventSpace(_password2.value, $event, 'password2')"
                                                   (focusout)="confirmationFail()"
                                                   (focusin)="removeMessage()"
                                                   (input)="validForm()" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-offset-2 col-md-10">
                                            <span id="errorPasswordMessage"></span>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>